import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getAnalytics } from 'firebase/analytics';

// Your web app's Firebase configuration
// For production, these should be set as environment variables
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyBiWcZ65YKZ1Yg_lJXabZ7RArPlpjN6_bs",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "logistiat-saas.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "logistiat-saas",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "logistiat-saas.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "577121011242",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:577121011242:web:3c614d9da14218ff82a553",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-N64SYTB5QX"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
export const analytics = getAnalytics(app);

export default app; 